// @ts-nocheck


import queryString from 'query-string';





import {
  fetchRequest,
  downloadRequestWithToken,
  initialFetchListParams } from
'./index';

import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { convertDataFromServer as actConvertDataFromServer } from './act';
import { convertDataFromServer as convertDataFromServerGroupedList } from './executionBudget';


export const convertDataFromServer = (
measuringDeviceCertification) => (
{
  ...measuringDeviceCertification,
  paymentAmount: convertFromKopToRub(
    measuringDeviceCertification.paymentAmount
  ),
  act: measuringDeviceCertification.act ?
  actConvertDataFromServer(measuringDeviceCertification.act) :
  undefined
});

export const convertDataToServer = (
measuringDeviceCertification) => (
{
  ...measuringDeviceCertification,
  paymentAmount: convertFromRubToKop(measuringDeviceCertification.paymentAmount)
});

export const addMeasuringDeviceCertification = async (
measuringDeviceCertification) =>
{
  const added = await fetchRequest.post(
    '/measuringDeviceCertification',
    convertDataToServer(measuringDeviceCertification)
  );
  if (added) return added;
  throw new Error('Не удалось создать сертификацию средств измерений');
};

export const updateMeasuringDeviceCertification = async (
measuringDeviceCertification) =>
{
  const updated = await fetchRequest.put(
    '/measuringDeviceCertification',
    convertDataToServer(measuringDeviceCertification)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить сертификацию средств измерений');
};
export const deleteMeasuringDeviceCertification = async (
id) =>
{
  const deleted = await fetchRequest.delete(
    `/measuringDeviceCertification/${id}`
  );
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить сертификацию средств измерений');
};

export const fetchMeasuringDeviceCertification = async (
id,
params = {}) =>
{
  const measuringDeviceCertification = await fetchRequest.get(
    `/measuringDeviceCertification/${id}`,
    params
  );
  if (measuringDeviceCertification)
  return convertDataFromServer(measuringDeviceCertification);
  throw new Error('Не удалось получить сертификацию средств измерений');
};

export const fetchVehicleMeasuringDeviceCertifications = async (
vehicleId,
params = initialFetchListParams) =>
{
  const measuringDeviceCertifications = await fetchRequest.get(
    `/measuringDeviceCertification/vehicle/${vehicleId}`,
    {
      ...initialFetchListParams,
      ...params
    }
  );
  if (measuringDeviceCertifications) {
    return {
      ...measuringDeviceCertifications,
      data: measuringDeviceCertifications.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список сертификаций средств измерений');
};

export const fetchMeasuringDeviceCertifications = async (
params = initialFetchListParams) =>
{
  const measuringDeviceCertification = await fetchRequest.get(
    '/measuringDeviceCertification',
    {
      ...initialFetchListParams,
      ...params
    }
  );

  if (measuringDeviceCertification) {
    return {
      ...measuringDeviceCertification,
      data: measuringDeviceCertification.data.map(convertDataFromServer)
    };
  }

  throw new Error('Не удалось получить список сертификаций средств измерений');
};

export const updateAct = async (
params,
data) =>
{
  const measuringDeviceCertification = await fetchRequest.put(
    `/measuringDeviceCertification/updateActId?${queryString.stringify(
      params
    )}`,
    data
  );
  if (measuringDeviceCertification) {
    return {
      ...measuringDeviceCertification,
      data: measuringDeviceCertification.data.map(convertDataFromServer)
    };
  }
  throw new Error(
    'Не удалось закрепить акт за списоком сертификаций средств измерений'
  );
};

export const printReport = async (
params,
fileName) =>
{
  const isPrinted = await downloadRequestWithToken(
    '/measuringDeviceCertification/print',
    params,
    fileName
  );
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};

export const getTotalSum = async (params = {}) => {
  const sum = await fetchRequest.get(
    `/measuringDeviceCertification/totalSum`,
    params
  );
  if (sum || sum === 0) return convertFromKopToRub(sum);
  throw new Error('Не удалось получить сертификацию средств измерений');
};

export const groupedList = async (
params = {}) =>
{
  const groupedList = await fetchRequest.get(
    `/measuringDeviceCertification/groupedList`,
    params
  );
  if (groupedList)
  return {
    ...groupedList,
    data: groupedList.data.map(convertDataFromServerGroupedList)
  };
  throw new Error(
    'Не удалось получить сгруппированный список для исполнения бюджета'
  );
};

export default {
  groupedList,
  getTotalSum,
  printReport,
  updateAct,
  addMeasuringDeviceCertification,
  updateMeasuringDeviceCertification,
  deleteMeasuringDeviceCertification,
  fetchMeasuringDeviceCertification,
  fetchVehicleMeasuringDeviceCertifications,
  fetchMeasuringDeviceCertifications
};
